var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-container"},[_c('div',{ref:"dragRef",staticClass:"drag__wrapper",style:({ left: _vm.pos.x + 'vw', top: _vm.pos.y + 'vw' }),on:{"mousemove":_vm.onTouchMove,"touchmove":function($event){$event.stopPropagation();return _vm.onTouchMove.apply(null, arguments)}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }